import { useState } from "react";
import { Link } from "react-router-dom";
import { Gift, X } from "lucide-react";

const d = new Date();
export const BANNER_ON = (d.getMonth() === 10 && d.getDate() >= 25) || (d.getMonth() === 11 && d.getDate() <= 24);
const KEY = `ff-voucher-banner-${d.getFullYear()}`;

export const VoucherBanner = () => {
  const [hidden, setHidden] = useState(() => !BANNER_ON || localStorage.getItem(KEY) === "1");
  if (hidden) return null;
  return (
    <div data-testid="voucher-banner" role="region" aria-label="Gutschein-Hinweis" className="relative z-10 bg-[#161616] text-white">
      <div className="max-w-[1320px] mx-auto px-5 md:px-10 min-h-[44px] flex items-center justify-between gap-3 py-2">
        <Link to="/coaching#gutschein" data-testid="voucher-banner-link" className="tap flex items-center gap-2.5 text-sm leading-snug hover:text-[#F2A7F7] transition-colors min-w-0">
          <span className="w-7 h-7 rounded-full bg-[#BA00C5] flex items-center justify-center shrink-0"><Gift size={14} /></span>
          <span className="sm:truncate"><strong className="font-head">Weihnachten:</strong> Training verschenken<span className="hidden sm:inline"> – Gutschein für Personal Training, Ernährungscoaching oder Wunschbetrag</span> <span className="underline underline-offset-2 whitespace-nowrap">Mehr erfahren</span></span>
        </Link>
        <button type="button" data-testid="voucher-banner-close" aria-label="Hinweis schließen" onClick={() => { localStorage.setItem(KEY, "1"); setHidden(true); }} className="tap p-1.5 rounded-full text-white/70 hover:text-white hover:bg-white/10 transition-colors shrink-0"><X size={16} /></button>
      </div>
    </div>
  );
};
